import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getPowerGenerationSourceList } from '../../../slices/powerGenerationSource/thunk';
import AddEditPowerGenerationSourceModal from './Add_Edit/AddEditPowerGenerationSource';
import DeletePowerGenerationSourceModal from './Delete/DeletePowerGenerationSource';
import AddEditPowerGenerationSourceMaintenanceModal from './Add_Edit/AddEditPowerGenerationSourceMaintenance';
import PowerGenerationSourceFilesModal from './Modals/PowerGenerationSourceFilesModal';

const PowerGenerationSourceEnvironmentList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		data => ({
			powerGenerationSourceList: data.powerGenerationSourceList,
			isLoadingList: data.isLoadingList,
			isPowerGenerationSourceSuccess: data.isPowerGenerationSourceSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.rolesListSelect,
	// 	rolesListSelect => rolesListSelect
	// );

	// const rolesListSelect = useSelector(selectRolesList);

	const { powerGenerationSourceList, isLoadingList } = useSelector(
		selectorPowerGenerationSource
	);

	useEffect(() => {
		dispatch(getPowerGenerationSourceList());
	}, []);

	const [dataPowerGenerationSource, setDataPowerGenerationSource] = useState(
		{}
	);
	const [isEdit, setIsEdit] = useState(false);

	const [modal, setModal] = useState(false);
	const [modalMaintenance, setModalMaintenance] = useState(false);
	const [modalFilesPowerGenerationSource, setModalFilesPowerGenerationSource] =
		useState(false);

	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalMaintenance() {
		setModalMaintenance(!modalMaintenance);
	}

	function handleToggleModalFilesPowerGenerationSource() {
		setModalFilesPowerGenerationSource(!modalFilesPowerGenerationSource);
	}

	// Update Data
	const handleClickEdit = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModal();
	};

	// Update Data
	const handleClickMaintenance = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModalMaintenance();
	};

	const handleClickFilesPowerGenerationSource = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModalFilesPowerGenerationSource();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'powerGenerationSource',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const powerGenerationSourceData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(
														powerGenerationSourceData
													);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const powerGenerationSourceData =
														cellProps.row.original;
													handleClickFilesPowerGenerationSource(
														powerGenerationSourceData
													);
												}}
												title='Ver Documentos'
											>
												<i className='ri-file-search-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Estado Registro',
				accessorKey: 'power_generation_register_status_code',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const status =
						row?.original?.power_generation_register_status || {};
					const { code, name } = status;

					let badgeClass = '';

					// Define el color del badge según el valor del código
					switch (code) {
						case 'RE':
							badgeClass = 'bg-success-subtle text-success';
							break;
						case 'PFR':
							badgeClass = 'bg-danger-subtle text-danger';
							break;
						case 'NRE':
							badgeClass = 'bg-info-subtle text-info';
							break;
						default:
							badgeClass = 'bg-secondary-subtle text-secondary'; // Manejar un estado por defecto
					}

					return (
						<span className={`badge ${badgeClass}`}>
							{name ? name : 'Desconocido'}
						</span>
					);
				},
			},

			{
				header: 'Estado',
				accessorKey: 'power_generation_status.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{ header: 'Cod. RFP', accessorKey: 'rfp_code', size: 'auto' },
			{
				header: 'Establecimiento',
				accessorKey: 'establishment_name',
				accessorFn: row => row?.establishment?.name ?? row?.establishment_feeding_barges?.name ?? '-', // Extrae solo el nombre			
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentName =
						row?.original?.establishment?.name ||
						row?.original?.establishment_feeding_barges?.name ||
						'-';
					const establishmentId =
						row?.original?.establishment_id ||
						row?.original?.establishment_feeding_barges?._id;

					return establishmentId && establishmentName !== '-' ? (
						<span
							onClick={() =>
								window.open(
									`/establishment/summary/${establishmentId}`,
									'_blank'
								)
							}
							style={{
								cursor: 'pointer',
								color: 'var(--vz-primary)',
								textDecoration: 'none',
								fontWeight: 'bold',
							}}
						>
							<i className="ri-links-line"></i> {establishmentName}
						</span>
					) : (
						<span>{establishmentName}</span>
					);
				},
			},
			{
				header: 'Tipo de Establecimiento',
				accessorKey: 'establishment_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Artefacto Naval',
				accessorKey: 'feeding_barges.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{ header: 'Número de Serie', accessorKey: 'serial_number', size: 'auto' },
			{
				header: 'Horómetro',
				accessorKey: 'hour_meter',
				dataType: 'separator',
				size: 'auto',
			},
			{
				header: 'Última Actualización',
				accessorKey: 'date_hour_meter',
				dataType: 'date',
				size: 'auto',
			},
			{
				header: 'CO2 Nominal (Kg)',
				accessorKey: 'nominal_CO2',
				dataType: 'separator',
				size: 'auto',
				Cell: ({ row }) => {
					const { hour_meter, nominal_consumption } = row?.original || {};

					// Verifica que hour_meter y nominal_consumption no sean undefined o null antes de calcular
					const co2Nominal =
						hour_meter && nominal_consumption
							? hour_meter * nominal_consumption
							: 0;

					return (
						<span>{co2Nominal}</span> // Muestra el resultado dentro de un elemento JSX
					);
				},
			},
			// { header: 'Horómetro Mantención', accessorKey: 'hour_meter_maintenance', dataType: 'separator', size: 'auto' },
			// { header: 'Fecha Mantención', accessorKey: 'date_hour_meter_maintenance', dataType: 'date', size: 'auto' },
			{
				header: 'Tipo',
				accessorKey: 'power_generation_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Tipo de combustible',
				accessorKey: 'fuel_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{ header: 'Descripción', accessorKey: 'description' },
		],
		[handleClickEdit, handleClickFilesPowerGenerationSource]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								data={powerGenerationSourceList || []}
								isLoadingData={isLoadingList}
								nameFile={'fuentes_de_generación_de_energía'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditPowerGenerationSourceModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				edit_environment={true}
			/>

			<PowerGenerationSourceFilesModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isOpen={modalFilesPowerGenerationSource}
				handleToggleModal={handleToggleModalFilesPowerGenerationSource}
			/>
		</React.Fragment>
	);
};

export default PowerGenerationSourceEnvironmentList;
